import React, { createContext, useContext, useMemo, useState } from "react";
import { dictionaries } from "./translations";

const STORAGE_KEY = "dicio.docs.language";
const defaultLanguage = "es";
const I18nContext = createContext(null);

const getInitialLanguage = () => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return dictionaries[stored] ? stored : defaultLanguage;
};

const getNestedValue = (dictionary, key) =>
    key.split(".").reduce((value, segment) => (value ? value[segment] : undefined), dictionary);

export const I18nProvider = ({ children }) => {
    const [language, setLanguageState] = useState(getInitialLanguage);

    const setLanguage = (nextLanguage) => {
        const resolvedLanguage = dictionaries[nextLanguage] ? nextLanguage : defaultLanguage;
        window.localStorage.setItem(STORAGE_KEY, resolvedLanguage);
        setLanguageState(resolvedLanguage);
    };

    const value = useMemo(
        () => ({
            language,
            setLanguage,
            t: (key) => getNestedValue(dictionaries[language], key) || getNestedValue(dictionaries[defaultLanguage], key) || key,
        }),
        [language]
    );

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
    const context = useContext(I18nContext);
    if (!context) {
        throw new Error("useI18n debe usarse dentro de I18nProvider.");
    }
    return context;
};
